import React from 'react'

export default props => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M10 17l5-5-5-5v10z" />
    <path fill="none" d="M0 24V0h24v24H0z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Components/Icons/ArrowRight.js